'use client';

import React from 'react';
import { Translations } from '../types/i18n';
import { SDKResponse } from '@commercetools/frontend-sdk';
import { PageResponse } from '@commercetools/frontend-sdk/lib/types/api/page';
import { sdk } from '../sdk';
import { GetAccountActionReturn } from '../sdk/composable-commerce/types/actions/AccountActions';
import I18nProvider from './i18n';
import { SWRProvider } from './swr';
import TracingProvider from './tracing';
import { UrlProvider } from './url';

export interface ProvidersProps {
  translations: Translations;
  accountResult?: SDKResponse<GetAccountActionReturn>;
  page: SDKResponse<PageResponse>;
  locale: string;
  hostname: string;
}

export const Providers = ({
  translations,
  accountResult,
  page,
  locale,
  hostname,
  children,
}: React.PropsWithChildren<ProvidersProps>) => {
  sdk.defaultConfigure(locale);

  return (
    <TracingProvider page={page}>
      <I18nProvider translations={translations}>
        <UrlProvider hostname={hostname}>
          <SWRProvider value={{ fallback: { '/action/account/getAccount': accountResult } }}>{children}</SWRProvider>
        </UrlProvider>
      </I18nProvider>
    </TracingProvider>
  );
};
